import React, { useEffect, useState } from "react";

/**
 * Auto-cycles through a list of images. If only one, behaves like a plain <img>.
 * Includes dot indicators when multiple.
 */
export default function PortfolioImage({ item, className = "", interval = 3500 }) {
  const imgs = (item.images && item.images.length > 0 ? item.images : [item.image_url]).filter(Boolean);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (imgs.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % imgs.length), interval);
    return () => clearInterval(t);
  }, [imgs.length, interval]);

  return (
    <div className={`relative w-full h-full ${className}`}>
      {imgs.map((src, i) => (
        <img
          key={src + i}
          src={src}
          alt={item.title}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${
            i === idx ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}
      {imgs.length > 1 && (
        <div className="absolute bottom-3 right-3 flex gap-1.5 z-10" data-testid={`portfolio-dots-${item.id}`}>
          {imgs.map((_, i) => (
            <button
              key={i}
              type="button"
              onClick={(e) => { e.stopPropagation(); e.preventDefault(); setIdx(i); }}
              aria-label={`Photo ${i + 1}`}
              className={`w-2 h-2 transition-all ${i === idx ? "bg-white w-6" : "bg-white/50"}`}
              style={{ borderRadius: 1 }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
